module.exports = __webpack_public_path__ + "media/components/page-header/static/icon-heart-50223932f6585313fa7e1d57202daf16.svg";